import { render, staticRenderFns } from "./MemberAge.vue?vue&type=template&id=4381be07"
import script from "./MemberAge.vue?vue&type=script&lang=js"
export * from "./MemberAge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports